import { PawPrint } from 'lucide-react';
import clsx from 'clsx';

interface LogoProps {
  src?: string | null;
  alt?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  showText?: boolean;
  text?: string;
}

const sizeClasses = {
  sm: 'h-8 w-8',
  md: 'h-10 w-10',
  lg: 'h-16 w-16',
  xl: 'h-24 w-24',
};

const iconSizes = {
  sm: 'h-5 w-5',
  md: 'h-6 w-6',
  lg: 'h-10 w-10',
  xl: 'h-14 w-14',
};

const textSizes = {
  sm: 'text-sm',
  md: 'text-base',
  lg: 'text-xl',
  xl: 'text-2xl',
};

export default function Logo({
  src,
  alt = 'Logo',
  size = 'md',
  className,
  showText = false,
  text = 'VetSystem',
}: LogoProps) {
  const hasCustomLogo = src && src.trim() !== '';

  return (
    <div className={clsx('flex items-center gap-2', className)}>
      {hasCustomLogo ? (
        <img
          src={src}
          alt={alt}
          className={clsx(sizeClasses[size], 'rounded-lg object-cover')}
          onError={(e) => {
            // Si falla la carga de la imagen, mostrar el logo por defecto
            e.currentTarget.style.display = 'none';
            e.currentTarget.nextElementSibling?.classList.remove('hidden');
          }}
        />
      ) : null}
      <div
        className={clsx(
          sizeClasses[size],
          'rounded-lg bg-gradient-to-br from-taupe-500 to-taupe-700 flex items-center justify-center',
          hasCustomLogo && 'hidden'
        )}
      >
        <PawPrint className={clsx(iconSizes[size], 'text-cream-100')} />
      </div>
      {showText && (
        <span className={clsx(textSizes[size], 'font-bold text-taupe-700')}>
          {text}
        </span>
      )}
    </div>
  );
}
